






















import _ from 'underscore'
import { FEN } from '../types'
import { getMovePrefix } from '../utils'
import { defaultAnalysisOptions } from '../analysis/options'
import analysisCache from '../analysis/cache'

type Evaluation = string|number

interface AnalysisData {
  move: string
  engine: string
  depth: number
  evaluation: number
  color: string
  variationIndex: number
}

const getFormattedEvaluation = (evaluation: Evaluation, polarity: number) => {
  let color = ''
  if (_.isNumber(evaluation)) {
    evaluation *= polarity
    evaluation = evaluation > 0 ? `+${evaluation}` : evaluation
    if (evaluation > 0.5) {
      color = 'green'
    } else if (evaluation < -0.5) {
      color = 'red'
    }
  } else if (evaluation.indexOf("mate") === 0) {
    const regex = /mate (-?\d+)/
    const score = Number(regex.exec(evaluation)[1]) * polarity
    if (score < 0) {
      color = 'red'
    } else {
      color = 'green'
    }
    evaluation = `Mate in ${Math.abs(score)}`
  }
  return { color, evaluation }
}

export default {
  methods: {
    showMoreMoves() {
      const multipv = this.$store.state.multipv === 1 ? 3 : 1
      this.$store.dispatch(`setAnalysisOptions`, Object.assign(
        {}, this.$store.getters.analysisOptions, { multipv }
      ))
    },
    higherDepth() {
      const depth = this.$store.state.depth === 12 ? 16 : 12
      this.$store.dispatch(`setAnalysisOptions`, Object.assign(
        {}, this.$store.getters.analysisOptions, { depth }
      ))
    },
  },

  computed: {
    movesButtonText(): string {
      return this.$store.state.multipv === 1 ? '+ show more moves' : '- show less moves'
    },

    depthButtonText(): string {
      return this.$store.state.depth === 12 ? '+ higher depth' : '- lower depth'
    },

    analysisData(): Array<AnalysisData> {
      const analysis = this.$store.state.currentAnalysis
      if (!analysis) {
        return
      }
      const variations = analysis.variations
      if (!variations[0].firstMove) {
        return
      }
      if (this.$store.getters.currentFen !== analysis.fen) {
        return
      }
      const data = []
      for (let k = 0; k < variations.length; k++) {
        const variation = variations[k]
        const polarity = (/ w /.test(analysis.fen) ? 1 : -1) * this.$store.state.boardPolarity
        const { color, evaluation } = getFormattedEvaluation(variation.score, polarity)
        data.push({
          move: `${getMovePrefix(this.$store.state.positionIndex)} ${variation.firstMove}`,
          engine: analysis.engine,
          depth: variation.depth,
          evaluation,
          color,
          index: k,
        })
      }
      return data
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/analysis_info.vue